


const sectorOptions = {
    title: "Sector decomposition",
    pieStartAngle: 135,
    slices: {
        0: {color: "#f0a652"},
        1: {color: "#d53f73"},
        2: {color: "#6f76ad"},
    },
};

const milestoneOptions = {
    title: "Number of companies per milestone",
    // chartArea: { width: "70%" },
    legend: 'none',
    hAxis: {
        title: "Next Milestone",
        ticks: [1, 2, 3, 4, 5, 6, 7],
        // positionTicks:[5, 2, 3, 4, 5, 6, 7],
    },
    vAxis: {
        // viewWindowMode: 'explicit',
        // viewWindow: {
        //     min: 0,
        // },
        title: "Number of companies",
    },
    histogram: {
        bucketSize: 0.01,
        minValue: 1,
        maxValue: 6,
        maxNumBuckets: 7

    }
};

const revOptions = {
    title: "Revenue growth ambition (green) \nBenchmark: 100% yearly growth (grey)",
    hAxis: {
        title: "Company age",
        minValue: 0,
        viewWindowMode: 'explicit',
        viewWindow: {
            max: 10,
            min: 0
        }
        // maximum: 5 ,
    },
    vAxis: {
        title: "Total revenue (€)",
        minValue: 0,
        // scaleType: 'log'
    },

    legend: "none",
    series:
        [{color: "red"},
            {color: "grey"},
            {color: "green"},
            , {color: "green"},
            , {color: "blue"}
        ],
    trendlines: {
        0: {
            type: "exponential",
            color: "green",
        },
        1: {
            type: "exponential",
            color: "lightgrey",
        },
    },
};

const scanUsageOptions = {
    title: "Total number of scans (since March 2022)",
    curveType: "function",
    legend: "none",
    vAxis: {title: "Total scans", minValue: 0},
};

const devboxOptions = {
    title: "Development Box (size: age)",
    chartArea: {
        width: "60%",
        height: "60%"
    },
    hAxis: {title: "Next Milestone (long term development)", minValue: 0, maxValue: 6},
    vAxis: {title: "Consistency Score (short term development)", minValue: 0, maxValue: 10},
    bubble: {textStyle: {fontSize: 11}},
    text: "none",
    axes: {
        x: {
            "Next Milestone (long term development)": {label: "Next Milestone (long term development)"}

        },
        y: {
            "Consistency Score (short term development)": {label: "Consistency Score (short term development)"}

        },
    },
};

const devboxtableOptions = {
    showRowNumber: true,
    // pageSize: 14,
};

export {
    sectorOptions,
    milestoneOptions,
    revOptions,
    scanUsageOptions,
    devboxOptions,
}